import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <h2 className="footer__text">&copy; 2024</h2>
    </footer>
  );
}

export default Footer;
